<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-15 14:13:14
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 23:27:06
-->

<template>
  <section>
    <!-- <itemsDetail></itemsDetail> -->
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="topic-outer xq_common_text">
      <div
          class="appraisal-center fonts tab_info_casertyudsad"
          v-for="(item, index) in realItem"
          :key="index"
      >
        <div class="xq_common_textTitle">{{ emptyShow(item.con) }}</div>
        <div class="innner" v-if="id == 0">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>分类:</span> {{ emptyShow(detailData.categoryName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>名称:</span> {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                $ {{ emptyShow(detailData.payMoney) / 100 }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.paymentTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.payTime) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-table
                :data="detailData.skus"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="名称"
                  prop="name"
                  width="140"
              ></el-table-column>
              <el-table-column
                  label="国家/地区标识"
                  prop="countryCode"
                  width="150"
              ></el-table-column>
              <el-table-column label="价格" prop="payMoney" width="100">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payPrice) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="权益" prop="payMoney" >
                <template slot-scope="scope">
                  <span v-for="(item,index) in scope.row.skuList" :key="index">
                    {{item.name}} 、
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.nickName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单邮箱:</span> {{ emptyShow(detailData.email) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>设备标识:</span> {{ emptyShow(detailData.deviceId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span> {{ emptyShow(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span> {{ emptyShow(detailData.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>国家标识:</span> {{ emptyShow(detailData.countryCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>语言标识:</span> {{ emptyShow(detailData.languageCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户IP:</span> {{ emptyShow(detailData.ip) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 4">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ emptyShow(detailData.channelMchVo).name }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 5">
            <el-table
                :data="detailData.orderPayVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentType" width="120">
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="mchName" width="180"></el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="innner" v-if="id == 1">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>会员:</span>
                {{ emptyShow(detailData.vipInfoVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>有效期:</span>
                {{ detailData.vipInfoVo ? `${emptyShow(detailData.vipInfoVo).days}` : "" }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                {{ detailData.payMoney ? `$ ${detailData.payMoney / 100}` : "" }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.paymentTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.payTime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>来源:</span>
                {{
                  detailData.newUserOrder == 1
                      ? "一转"
                      : detailData.newUserOrder == 2
                      ? "二转"
                      : "其它"
                }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>绑定手机号:</span>{{ emptyShow(detailData.phone) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.userName) }}
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>下单账号:</span> {{ emptyShow(detailData.userAccount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span> {{ emptyShow(detailData.userPhone) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span
                >{{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span
                >{{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                <span>{{ emptyShow(detailData.companyVo).fullName }}</span>
              </div>
            </el-col>
          </el-row>

          <!-- {{detailData.orderPayVos}} -->
          <el-row v-if="item.index == 4">
            <el-table
                :data="detailData.orderPayVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  {{ scope.row.payMoney ? "$ " + (scope.row.payMoney) / 100 : "" }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentTypeName">
                <template slot-scope="scope">
                  {{
                    scope.row.paymentType == "ALIPAY"
                        ? "支付宝"
                        : scope.row.paymentType == "WECHAT"
                        ? "微信支付"
                        : "银联支付"
                  }}
                </template>
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="paymentMchId">
                <template slot-scope="scope">
                  <!-- {{scope.row.paymentMchVo.mchName}} -->
                  {{ emptyShow(scope.row.paymentMchVo).mchName }}
                </template>
              </el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="220">
                <template slot-scope="scope" v-if="scope.row">
                  <el-button type="primary" plain size="small"
                  >回调信息
                  </el-button
                  >
                  <template v-if="userInfo && userInfo.operateStatus==1">
                    <template v-if="scope.row.payStatus == 10">
                      <el-button
                          @click="tuikuanList(scope.row)"
                          type="danger"
                          size="small"
                          v-if="numType"
                      >退款
                      </el-button
                      >
                      <el-button
                          @click="operationShowTime"
                          type="danger"
                          size="small"
                          v-else
                      >退款
                      </el-button
                      >
                    </template>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="innner" v-if="id == 2">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>流水号:</span> {{ emptyShow(detailData.payCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>业务类型:</span>
                {{ detailData.bizTypeName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>事件:</span>
                {{ emptyShow(detailData.payTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付金额:</span>
                {{
                  emptyShow(detailData.payMoney)
                      ? `$ ${detailData.payMoney / 100}`
                      : ""
                }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{
                  detailData.paymentType == "ALIPAY"
                      ? "支付宝"
                      : detailData.paymentType == "WECHAT"
                      ? "微信支付"
                      : "银联支付"
                }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.utime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间：</span>
                {{ emptyShow(detailData.finishTime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>商户：</span>
                {{
                  detailData.paymentMchVo
                      ? `${emptyShow(detailData.paymentMchVo).mchName} ( ${emptyShow(detailData.paymentMchId)} )`
                      : ""
                }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-table
                :data="detailData.skus"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="id"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="名称"
                  prop="name"
                  width="140"
              ></el-table-column>
              <el-table-column
                  label="国家/地区标识"
                  prop="countryCode"
                  width="150"
              ></el-table-column>
              <el-table-column label="价格" prop="payMoney" width="100">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payPrice) / 100 }}/

                  {{  scope.row.intervalCount+scope.row.billingInterval }}
                </template>
              </el-table-column>
              <el-table-column label="试用价格" prop="payMoney" width="100">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.trialPrice) / 100 }}/
                  {{  scope.row.trialDays }}天
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-table
                :data="detailData.orderPayNotifyVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="支付ID"
                  prop="exportId"
                  min-width="230"
              ></el-table-column>
              <el-table-column
                  label="支付账号"
                  prop="exportAccount"
                  min-width="230"
              ></el-table-column>
              <el-table-column
                  label="收款ID"
                  prop="enterId"
                  min-width="230"
              ></el-table-column>
              <el-table-column
                  label="收款账号"
                  prop="enterAccount"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="回调时间" prop="ctime" min-width="220">
              </el-table-column>
            </el-table>
          </el-row>

          <el-row v-if="item.index == 4">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.nickName) }}
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>下单账号:</span> {{ emptyShow(detailData.userAccount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span> {{ emptyShow(detailData.userPhone) }}
              </div>
            </el-col>
          </el-row>

          <!-- {{detailData.orderPayVos}} -->
          <el-row v-if="item.index == 5">
            <el-table
                :data="detailData.orderPayItemVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="订单号"
                  prop="orderNumber"
                  min-width="200"
              ></el-table-column>
              <el-table-column
                  label="订单名称"
                  prop="name"
                  min-width="150"
              ></el-table-column>
              <el-table-column label="支付状态" prop="statusName">
              </el-table-column>
              <el-table-column label="下单时间" prop="ctime" min-width="200">
              </el-table-column>

              <el-table-column fixed="right" label="操作" min-width="160">
                <template slot-scope="scope" v-if="scope.row">
                  <el-button type="primary" plain size="small" @click="goDetails(scope.row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="innner" v-if="id == 3">
          <el-row v-if="item.index == 1" style="margin-top:0px">
            <el-col :span="24">
              <div class="grid-content bg-purple" style="align-items: center;display: flex">
                <span>头像:</span>
                <el-image
                    v-if="detailData.head"
                    style="width: 40px; height: 40px;border-radius: 50%"
                    :src="detailData.head"
                    fit="cover"
                ></el-image>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>昵称:</span>
                {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span>
                {{ emptyShow(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span>
                {{ emptyShow(detailData.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span>
                {{ emptyShow(detailData.phone) }}
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>状态:</span>
                <span style="color: #409eff">
                  {{ detailData.status == 0 ? "禁用" : "正常" }}</span
                >
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.userVipVo">
              <div class="grid-content bg-purple" v-if="detailData.userVipVo.vipInfoVo">
                <span>会员:</span>
                <span style="color: #409eff">{{ detailData.userVipVo.vipInfoVo.name }}会员</span>
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.userVipVo">
              <div class="grid-content bg-purple">
                <span>有效期:</span>
                <span style="color: #409eff">{{ detailData.userVipVo.expireTime }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="item.index == 2">
            <el-table
                :data="detailData.userAccountVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="类型"
                  prop="accountTypeName"
                  min-width="110"
              ></el-table-column>
              <el-table-column
                  label="账号"
                  prop="account"
                  min-width="350"
              ></el-table-column>
              <el-table-column label="状态" prop="status" min-width="150">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      disabled
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  label="创建IP"
                  prop="createIp"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="创建时间" prop="ctime" min-width="220">
              </el-table-column>
            </el-table>
          </el-row>

          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>时间:</span>
                {{ emptyShow(detailData.userRecentVo).recentTime }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>IP:</span>
                {{
                  emptyShow(detailData.userRecentVo)
                      ? emptyShow(detailData.userRecentVo.recentIp)
                      : ""
                }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>地址:</span>
                {{ emptyShow(detailData.userRecentVo).provinceName }},
                {{ emptyShow(detailData.userRecentVo).cityName }},
                {{ emptyShow(detailData.userRecentVo).areaName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>应用:</span>
                {{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.appInfoVo) && emptyShow(detailData.userRecentVo.appInfoVo.appName) ? emptyShow(detailData.userRecentVo.appInfoVo.appName) : ''
                }}（{{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.appInfoVo) && emptyShow(detailData.userRecentVo.appInfoVo.swid) ? emptyShow(detailData.userRecentVo.appInfoVo.swid) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>渠道:</span>
                {{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.channelAccountVo) && emptyShow(detailData.userRecentVo.channelAccountVo.name) ? emptyShow(detailData.userRecentVo.channelAccountVo.name) : ''
                }}（{{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.channelAccountVo) && emptyShow(detailData.userRecentVo.channelAccountVo.code) ? emptyShow(detailData.userRecentVo.channelAccountVo.code) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>版本:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceVersion) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>场景:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceSceneName) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>系统:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceModel) : '' }}
              </div>
            </el-col>
          </el-row>

          <el-row v-if="item.index == 4">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>时间:</span>
                {{ emptyShow(detailData.userRegisterVo) ? emptyShow(detailData.userRegisterVo.registerTime) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>IP:</span>
                {{ emptyShow(detailData.userRegisterVo).registerIp }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>地址:</span> {{ emptyShow(emptyShow(detailData.userRegisterVo).provinceName) }}
                {{ emptyShow(emptyShow(detailData.userRegisterVo).cityName) }}
                {{ emptyShow(emptyShow(detailData.userRegisterVo).areaName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>应用:</span>
                <!-- {{ emptyShow(detailData.userRegisterVo.appInfoVo.appName) }} -->
                <!--                {{ emptyShow(emptyShow(detailData.userRegisterVo).appInfoVo).appName }}-->
                {{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.appInfoVo) && emptyShow(detailData.userRegisterVo.appInfoVo.appName) ? emptyShow(detailData.userRegisterVo.appInfoVo.appName) : ''
                }}（{{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.appInfoVo) && emptyShow(detailData.userRegisterVo.appInfoVo.swid) ? emptyShow(detailData.userRegisterVo.appInfoVo.swid) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>渠道:</span>
                {{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.channelAccountVo) && emptyShow(detailData.userRegisterVo.channelAccountVo.name) ? emptyShow(detailData.userRegisterVo.channelAccountVo.name) : ''
                }}（{{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.channelAccountVo) && emptyShow(detailData.userRegisterVo.channelAccountVo.code) ? emptyShow(detailData.userRegisterVo.channelAccountVo.code) : ''
                }}）
                <!-- ( {{ detailData.userRegisterVo.channelAccountId }} ) -->
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>版本:</span>
                {{ emptyShow(detailData.userRegisterVo.deviceVersion) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>场景:</span>
                {{ emptyShow(detailData.userRegisterVo.deviceSceneName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>系统:</span>
                {{ emptyShow(detailData.userRegisterVo.deviceModel) }}
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="innner" v-if="id == 4">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>分类:</span> {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>姓氏:</span>
                {{ emptyShow(detailData.surname) }}
              </div>
            </el-col>

            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
               $ {{ emptyShow(detailData.payMoney) / 100 }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.paymentTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.payTime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>来源:</span>
                <span v-if="!isEmpty(detailData.newChannelOrder)">
                  {{
                    detailData.newChannelOrder == 1
                        ? "一转"
                        : detailData.newChannelOrder == 2
                        ? "二转"
                        : "其它"
                  }}</span
                >
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>绑定手机号:</span>{{ emptyShow(detailData.phone) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.userName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单账号:</span> {{ emptyShow(detailData.userAccount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span> {{ emptyShow(detailData.userPhone) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span> {{ emptyShow(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>生日:</span> {{ emptyShow(detailData.birthday) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户IP:</span> {{ emptyShow(detailData.ip) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ emptyShow(detailData.channelMchVo).name }}
              </div>
            </el-col>
          </el-row>

          <!-- {{detailData.orderPayVos}} -->
          <el-row v-if="item.index == 4">
            <el-table
                :data="detailData.orderPayVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentTypeName">
                <template slot-scope="scope">
                  {{
                    scope.row.paymentType == "ALIPAY"
                        ? "支付宝"
                        : scope.row.paymentType == "WECHAT"
                        ? "微信支付"
                        : "银联支付"
                  }}
                </template>
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="paymentMchId">
                <template slot-scope="scope" v-if="scope.row.paymentMchId">
                  {{ emptyShow(scope.row.paymentMchVo).mchName }}
                  <!-- {{ scope.row.paymentMchId }} -->
                </template>
              </el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="240">
                <template slot-scope="scope">
                  <!-- <span v-for="(item,i) in scope.row.detail" :key="i" style="text-align: left;white-space:nowrap;"> -->
                  <el-tooltip
                      placement="top"
                      popper-class="testtooltip"
                      effect="light"
                  >
                    <div
                        slot="content"
                        v-if="
                        emptyShow(scope.row.orderPayVos) &&
                        emptyShow(scope.row.orderPayVos).orderPayNotifyVos!=undefined
                      "
                    >
                      <h5>回调信息</h5>
                      <p>
                        支付ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).exportId
                        }}
                      </p>
                      <p>
                        支付账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos).exportAccount
                        }}
                      </p>
                      <p>
                        收款ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterId
                        }}
                      </p>
                      <p>
                        收款账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterAccount
                        }}
                      </p>
                      <p>
                        回调时间：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).ctime
                        }}
                      </p>
                      <br/>
                    </div>
                    <div v-else slot="content">暂无回调信息</div>
                    <span>
                      <el-button
                          type="primary"
                          plain
                          size="small"
                          @click="visible = true"
                      >回调信息</el-button
                      >
                    </span>
                  </el-tooltip>
                  <!-- </span> -->
                  <template v-if="userInfo && userInfo.operateStatus==1">
                    <template v-if="scope.row.payStatus == 10">
                      <el-button
                          @click="reFund(scope.row)"
                          type="danger"
                          size="small"
                          style="margin-left: 20px"
                          v-if="numType"
                      >退款
                      </el-button
                      >
                      <el-button
                          style="margin-left: 20px"
                          @click="operationShowTime"
                          type="danger"
                          size="small"
                          v-else
                      >退款
                      </el-button
                      >
                    </template>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="innner" v-if="id == 5">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>名称:</span> {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                $ {{ emptyShow(detailData.payMoney) / 100 }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.paymentTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.payTime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>来源:</span>
                <span v-if="!isEmpty(detailData.newChannelOrder)">
                  {{
                    detailData.newChannelOrder == 1
                        ? "一转"
                        : detailData.newChannelOrder == 2
                        ? "二转"
                        : "其它"
                  }}</span
                >
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>绑定手机号:</span>{{ emptyShow(detailData.phone) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 2">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.userName) }}
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>下单账号:</span> {{ emptyShow(detailData.userAccount) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span> {{ emptyShow(detailData.userPhone) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户IP:</span> {{ emptyShow(detailData.ip) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ emptyShow(detailData.channelMchVo).name }}
              </div>
            </el-col>
          </el-row>

          <!-- {{detailData.orderPayVos}} -->
          <el-row v-if="item.index == 4">
            <el-table
                :data="detailData.orderPayVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentTypeName">
                <template slot-scope="scope">
                  {{
                    scope.row.paymentType == "ALIPAY"
                        ? "支付宝"
                        : scope.row.paymentType == "WECHAT"
                        ? "微信支付"
                        : "银联支付"
                  }}
                </template>
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="paymentMchId">
                <template slot-scope="scope" v-if="scope.row.paymentMchId">
                  {{ emptyShow(scope.row.paymentMchVo).mchName }}
                  <!-- {{ scope.row.paymentMchId }} -->
                </template>
              </el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="240">
                <template slot-scope="scope">
                  <!-- <span v-for="(item,i) in scope.row.detail" :key="i" style="text-align: left;white-space:nowrap;"> -->
                  <el-tooltip
                      placement="top"
                      popper-class="testtooltip"
                      effect="light"
                  >
                    <div
                        slot="content"
                        v-if="
                        emptyShow(scope.row.orderPayVos) &&
                        emptyShow(scope.row.orderPayVos).orderPayNotifyVos!=undefined
                      "
                    >
                      <h5>回调信息</h5>
                      <p>
                        支付ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).exportId
                        }}
                      </p>
                      <p>
                        支付账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos).exportAccount
                        }}
                      </p>
                      <p>
                        收款ID：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterId
                        }}
                      </p>
                      <p>
                        收款账号：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).enterAccount
                        }}
                      </p>
                      <p>
                        回调时间：{{
                          emptyShow(
                              scope.row.orderPayVos.orderPayNotifyVos
                          ).ctime
                        }}
                      </p>
                      <br/>
                    </div>
                    <div v-else slot="content">暂无回调信息</div>
                    <span>
                      <el-button
                          type="primary"
                          plain
                          size="small"
                          @click="visible = true"
                      >回调信息</el-button
                      >
                    </span>
                  </el-tooltip>
                  <!-- </span> -->
                  <template v-if="userInfo && userInfo.operateStatus==1">
                    <template v-if="scope.row.payStatus == 10">
                      <el-button
                          @click="reFund(scope.row)"
                          type="danger"
                          size="small"
                          style="margin-left: 20px"
                          v-if="numType"
                      >退款
                      </el-button
                      >
                      <el-button
                          style="margin-left: 20px"
                          @click="operationShowTime"
                          type="danger"
                          size="small"
                          v-else
                      >退款
                      </el-button
                      >
                    </template>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="innner" v-if="id == 6">
          <el-row v-if="item.index == 1" style="margin-top:0px">
            <el-col :span="24">
              <div class="grid-content bg-purple" style="align-items: center;display: flex">
                <span>头像:</span>
                <el-image
                    v-if="detailData.head"
                    style="width: 40px; height: 40px;border-radius: 50%"
                    :src="detailData.head"
                    fit="cover"
                ></el-image>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>昵称:</span>
                {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span>
                {{ emptyShow(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span>
                {{ emptyShow(detailData.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>手机号:</span>
                {{ emptyShow(detailData.phone) }}
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>状态:</span>
                <span style="color: #409eff">
                  {{ detailData.status == 0 ? "禁用" : "正常" }}</span
                >
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.userVipVo">
              <div class="grid-content bg-purple" v-if="detailData.userVipVo.vipInfoVo">
                <span>会员:</span>
                <span style="color: #409eff">{{ detailData.userVipVo.vipInfoVo.name }}会员</span>
              </div>
            </el-col>
            <el-col :span="8" v-if="detailData.userVipVo">
              <div class="grid-content bg-purple">
                <span>有效期:</span>
                <span style="color: #409eff">{{ detailData.userVipVo.expireTime }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="item.index == 2">
            <el-table
                :data="detailData.userAccountVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="100"
              >
              </el-table-column>
              <el-table-column
                  label="类型"
                  prop="accountTypeName"
                  min-width="110"
              ></el-table-column>
              <el-table-column
                  label="账号"
                  prop="account"
                  min-width="350"
              ></el-table-column>
              <el-table-column label="状态" prop="status" min-width="150">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      disabled
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  label="创建IP"
                  prop="createIp"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="创建时间" prop="ctime" min-width="220">
              </el-table-column>
            </el-table>
          </el-row>

          <el-row v-if="item.index == 3">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>时间:</span>
                {{ emptyShow(detailData.userRecentVo).recentTime }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>IP:</span>
                {{
                  emptyShow(detailData.userRecentVo)
                      ? emptyShow(detailData.userRecentVo.recentIp)
                      : ""
                }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>地址:</span>
                {{ emptyShow(detailData.userRecentVo).provinceName }},
                {{ emptyShow(detailData.userRecentVo).cityName }},
                {{ emptyShow(detailData.userRecentVo).areaName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>应用:</span>
                {{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.appInfoVo) && emptyShow(detailData.userRecentVo.appInfoVo.appName) ? emptyShow(detailData.userRecentVo.appInfoVo.appName) : ''
                }}（{{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.appInfoVo) && emptyShow(detailData.userRecentVo.appInfoVo.swid) ? emptyShow(detailData.userRecentVo.appInfoVo.swid) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>渠道:</span>
                {{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.channelAccountVo) && emptyShow(detailData.userRecentVo.channelAccountVo.name) ? emptyShow(detailData.userRecentVo.channelAccountVo.name) : ''
                }}（{{
                  emptyShow(detailData.userRecentVo) && emptyShow(detailData.userRecentVo.channelAccountVo) && emptyShow(detailData.userRecentVo.channelAccountVo.code) ? emptyShow(detailData.userRecentVo.channelAccountVo.code) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>版本:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceVersion) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>场景:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceSceneName) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>系统:</span>
                {{ emptyShow(detailData.userRecentVo) ? emptyShow(detailData.userRecentVo.deviceModel) : '' }}
              </div>
            </el-col>
          </el-row>

          <el-row v-if="item.index == 4">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>时间:</span>
                {{ emptyShow(detailData.userRegisterVo) ? emptyShow(detailData.userRegisterVo.registerTime) : '' }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>IP:</span>
                {{ emptyShow(detailData.userRegisterVo).registerIp }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>地址:</span> {{ emptyShow(emptyShow(detailData.userRegisterVo).provinceName) }}
                {{ emptyShow(emptyShow(detailData.userRegisterVo).cityName) }}
                {{ emptyShow(emptyShow(detailData.userRegisterVo).areaName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>应用:</span>
                <!-- {{ emptyShow(detailData.userRegisterVo.appInfoVo.appName) }} -->
                <!--                {{ emptyShow(emptyShow(detailData.userRegisterVo).appInfoVo).appName }}-->
                {{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.appInfoVo) && emptyShow(detailData.userRegisterVo.appInfoVo.appName) ? emptyShow(detailData.userRegisterVo.appInfoVo.appName) : ''
                }}（{{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.appInfoVo) && emptyShow(detailData.userRegisterVo.appInfoVo.swid) ? emptyShow(detailData.userRegisterVo.appInfoVo.swid) : ''
                }}）
              </div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content bg-purple">
                <span>渠道:</span>
                {{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.channelAccountVo) && emptyShow(detailData.userRegisterVo.channelAccountVo.name) ? emptyShow(detailData.userRegisterVo.channelAccountVo.name) : ''
                }}（{{
                  emptyShow(detailData.userRegisterVo) && emptyShow(detailData.userRegisterVo.channelAccountVo) && emptyShow(detailData.userRegisterVo.channelAccountVo.code) ? emptyShow(detailData.userRegisterVo.channelAccountVo.code) : ''
                }}）
                <!-- ( {{ detailData.userRegisterVo.channelAccountId }} ) -->
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>版本:</span>
                <span v-if="detailData.userRegisterVo && detailData.userRegisterVo.deviceVersion">
                  {{ emptyShow(detailData.userRegisterVo.deviceVersion) }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>场景:</span>
                <span v-if="detailData.userRegisterVo && detailData.userRegisterVo.deviceSceneName">
                  {{ emptyShow(detailData.userRegisterVo.deviceSceneName) }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>系统:</span>
                <span v-if="detailData.userRegisterVo && detailData.userRegisterVo.deviceModel">
                  {{ emptyShow(detailData.userRegisterVo.deviceModel) }}
                </span>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="item.index == 5">
            <div class="roleRight_Container public-table-data">
              <el-table
                  :data="tableData"
                  size="medium"
                  border
                  style="width: 100%"
                  row-key="customerServiceId"
                  v-loading="loading"
              >
                <el-table-column fixed label="序号" type="index" width="100">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" min-width="200">
                </el-table-column>
                <el-table-column prop="orderNumber" label="订单号" min-width="200">
                </el-table-column>
                <el-table-column prop="payMoney" label="订单金额" min-width="100">
                  <template slot-scope="scope">
                    $ {{ emptyShow(scope.row.payMoney) / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="payMoney" label="支付金额" min-width="100">
                  <template slot-scope="scope">
                    $ {{ emptyShow(scope.row.payMoney) / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="payStatusName" label="支付状态">
                </el-table-column>
                <el-table-column prop="appName" label="下单应用" min-width="120">
                </el-table-column>
                <el-table-column prop="channelCode" label="下单渠道" width="120">
                  <template slot-scope="scope">
                    <span>{{scope.row.channelName}}({{scope.row.channelCode}})</span>
                  </template>
                </el-table-column>
                <el-table-column prop="newChannelOrder" label="来源">
                  <template slot-scope="scope">
                    {{
                      scope.row.newChannelOrder == 1
                          ? "一转"
                          : scope.row.newChannelOrder == 2
                          ? "二转"
                          : "其它"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" min-width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                  <template slot-scope="scope">
                    <div class="button_code">
                      <el-button
                          @click="getOrderDetail(scope.row)"
                          size="small"
                      >详情
                      </el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="roleRight_pagenation" style="text-align: center;margin-top: 10px">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="page.pageNo"
                  :page-sizes="[PAGE_SIZE, 15, 20, 25]"
                  :page-size="page.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="countList"
              >
              </el-pagination>
            </div>
          </el-row>
        </div>

      </div>
      <operation-confirmation @closeOperation="publicMethios"
                              :operationVisible="operationVisible"></operation-confirmation>
    </div>
  </section>
</template>

<script>
// import itemsDetail from "../layout/components/itemsDetail.vue";

import {isEmpty, emptyShow} from "../../utils/tools/index";
import OperationConfirmation from "../../components/OperationConfirmation";
import {
  PAGE_SIZE,
} from "@/config";

export default {
  components: {
    // itemsDetail,
    OperationConfirmation
  },
  data() {
    return {
      PAGE_SIZE,
      //分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      countList: 0,
      emptyShow,
      isEmpty,
      id: "",
      realItem: [], //展示信息模块
      title: "",
      detailData: [],
      loading: false,
      operationVisible: false,
      numType: false,
      tableData: [],
    };
  },
  activated() {
    this.getOrgData();
  },
  created() {
    if (window.sessionStorage.getItem('operationKey')) {
      this.numType = true
    }
    this.getOrgData();
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route(to, form) {
      if (to.query.value) {
        let toOrderNum = JSON.parse(to.query.value)
        let formOrderNum = JSON.parse(form.query.value)
        if (toOrderNum != formOrderNum) {
          this.getOrgData();
        }
      }
    }
  },
  methods: {
    //关闭
    publicMethios(e) {
      this.operationVisible = false
      if (e == 'open') {
        this.numType = true
        setTimeout(() => {
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        }, 1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true
    },

    //订单详情
    getOrderDetail(row) {
      if (row.bizType == 'vip') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 1,
            title: '会员订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/vip/order/info',
          }
        })
      } else if (row.bizType == 'exam') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 0,
            title: '测评订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/exam/order/info',
          }
        })
      } else if (row.bizType == 'pay') {
        this.$router.push({
        name: "SECOND_ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(row.examOrderNumber),
          value: JSON.stringify(row.orderNumber),
          path: `/secondPhase/order/info/${row.id}`,
        },
      });
        // this.$router.push({
        //   name: 'ORDER_DETAIL',
        //   query: {
        //     id: 2,
        //     title: '支付订单',
        //     key: 'payCode',
        //     value: JSON.stringify(row.orderNumber),
        //     path: '/pay/order/info',
        //   }
        // })
      } else if (row.bizType == 'znqm' || row.bizType == 'zncm' || row.bizType == 'znys' || row.bizType == 'zwds' || row.bizType == 'znhp') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 4,
            title: '国学订单',
            key: 'orderNumber',
            orderKey: 'bizType',
            value: JSON.stringify(row.orderNumber),
            Typevalue: JSON.stringify(row.bizType),
            path: '/guoxue/order/info',
          }
        })
      } else if (row.bizType == 'zncm') {

      } else if (row.bizType == 'gsqm') {

      } else if (row.bizType == 'taluo') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 5,
            title: '塔罗订单',
            key: 'orderNumber',
            value: JSON.stringify(row.orderNumber),
            path: '/tarot/order/info',
          }
        })
      }
    },

    goDetails(e) {
      if (e.bizType == 'vip') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 1,
            title: '会员订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/vip/order/info',
          }
        })
      } else if (e.bizType == 'znqm' || e.bizType == 'zncm' || e.bizType == 'znys' || e.bizType == 'zwds' || e.bizType == 'znhp') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 4,
            title: '国学订单',
            key: 'orderNumber',
            orderKey: 'bizType',
            value: JSON.stringify(e.orderNumber),
            Typevalue: JSON.stringify(e.bizType),
            path: '/guoxue/order/info',
          }
        })
      } else if (e.bizType == 'taluo') {
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 5,
            title: '塔罗订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/tarot/order/info',
          }
        })
      }else if(e.bizType == 'exam'){
        this.$router.push({
          name: 'ORDER_DETAIL',
          query: {
            id: 0,
            title: '测评订单',
            key: 'orderNumber',
            value: JSON.stringify(e.orderNumber),
            path: '/exam/order/info',
          }
        })
      } else if (e.bizType == 'pay') {
        this.$router.push({
        name: "SECOND_ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(e.examOrderNumber),
          value: JSON.stringify(e.orderNumber),
          path: `/secondPhase/order/info/${e.id}`,
        },
      });
        // this.$router.push({
        //   name: 'ORDER_DETAIL',
        //   query: {
        //     id: 2,
        //     title: '支付订单',
        //     key: 'payCode',
        //     value: JSON.stringify(e.orderNumber),
        //     path: '/pay/order/info',
        //   }
        // })
      }
    },
    /* 返回上一页 */
    goBack() {
      this.$router.go(-1);
    },
    /* 接收参数并获取初始值 */
    async getOrgData() {
      this.id = this.$route.query.id;
      let items = {
        fir: [
          {index: 1, con: "订单信息"},
          {index: 2, con: "已购SKU信息"},
          {index: 3, con: "用户信息"},
          {index: 4, con: "业务信息"},
          {index: 5, con: "支付信息"},
        ],
        sec: [
          {index: 1, con: "支付信息"},
          {index: 2, con: "已购SKU信息"},
          {index: 3, con: "回调信息"},
          {index: 4, con: "用户信息"},
          {index: 5, con: "业务信息"}, 
        ],
        thir: [
          {index: 1, con: "用户信息"},
          {index: 2, con: "账号信息"},
          {index: 3, con: "使用信息"},
          {index: 4, con: "注册信息"},
        ],
        sexThre: [
          {index: 1, con: "用户信息"},
          {index: 2, con: "账号信息"},
          {index: 3, con: "使用信息"},
          {index: 4, con: "注册信息"},
          {index: 5, con: "订单列表"},
        ],
      };
      switch (Number(this.id)) {
        case 0:
          this.realItem = items.fir;
          break;
        case 1:
          this.realItem = items.fir;
          break;
        case 2:
          this.realItem = items.sec;
          break;
        case 3:
          this.realItem = items.thir;
          break;
        case 4:
          this.realItem = items.thir;
          break;
        case 5:
          this.realItem = items.thir;
          break;
        case 6:
          this.realItem = items.sexThre;
          break;
        default:
          break;
      }
      this.title = this.$route.query.title;
      if (Number(this.id) == 4) {
        const {data: res} = await this.$get(
            `${this.$route.query.path}?${this.$route.query.key}=${JSON.parse(
                this.$route.query.value
            )}&${this.$route.query.orderKey}=${JSON.parse(
                this.$route.query.Typevalue
            )}`
        );
        if (res.data) this.detailData = res.data;

      } else {
        const {data: res} = await this.$get(
            `${this.$route.query.path}?${this.$route.query.key}=${JSON.parse(
                this.$route.query.value
            )}`
        );
        if (res.data) this.detailData = res.data;
      }
      if (this.$route.query.key == 'userId') {
        this.getUserInfoOrder()
      }
    },

    async getUserInfoOrder() {
      this.loading = true;
      const {data: res} = await this.$get('/kefu/user/order/list?pageNo='+this.page.pageNo+'&pageSize='+this.page.pageSize+'&userId=' + JSON.parse(
          this.$route.query.value
      ));
      this.loading = false
      if (res.data) {
        this.tableData = res.data;
        this.countList = res.page.count;
      } else {
        this.tableData = []
        this.countList = 0
      }
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getUserInfoOrder();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getUserInfoOrder();
    },


    //tool hover框
    handleClose(index) {
      this.$refs[`popover-${index}`].doClose();
    },

    //reFund发起退款

    async tuikuanList(row) {
      let payCodes = row.payCode
      let payCode = {
        payCode: payCodes
      }
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const {data: resData} = await this.$post(
            "/order/refund/info",
            payCode,
        );
        this.$message.success(resData.message);
        if (resData.result != 200) return;
        this.getOrgData()
      });
    },
    reFund(row) {
      let payCodes = row.payCode
      let payCode = {
        payCode: payCodes
      }
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const {data: resData} = await this.$post(
            "/order/refund/info",
            payCode,
        );
        if (resData.result != 200) return;
        this.$message.success("退款成功!");
        this.getOrgData()
      });
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

::v-deep .el-page-header__content {
  font-size: 16px;
  color: #303133;
}

.topic-outer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
  // padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appraisal-center {
    margin: 20px 0;
    border-radius: 6px;
    background: #fff;
    padding: 30px 20px;

    .innner {
      padding: 20px 20px 0;

      .grid-content {
        color: #888;

        span:first-child {
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
//  箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: white !important;
}

// 箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: white !important;
}

// 内容
.testtooltip {
  background: white !important;
  box-shadow: 1px 1px 10px 3px #d3d3d6;
}
</style>
